























































import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import ZenButton from '@reciprocity/button';
import { ZenLink } from 'zenComponents';
import ConnectorBox from '../box/ConnectorBox.vue';

import { PATHS } from '../../../router/paths';
import settingsUrl from './components/urlInput.vue';
import chooseAuthType from './components/chooseAuthType.vue';

import { ticketingSetup } from '@/utils/crudActions';

export default Vue.extend({
  name: 'ServicenowStep1Settings',
  components: {
    ZenButton,
    settingsUrl,
    chooseAuthType,
    ZenLink,
    ConnectorBox,
  },
  props: {
    tab: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      step: 1,
      connectionData: {
        method: 'basic',
        url: null,
        username: null,
        password: null,
        client_id: null,
        client_secret: null,
      },
      loading: <boolean>false,
      PATHS,
    };
  },
  computed: {
    ...mapGetters(['csrfToken', 'routes']),
    hasCredentials() {
      let hasUsernameAndPassword = !!this.connectionData.username && !!this.connectionData.password;
      let hasClientAndSecret = !!this.connectionData.client_id && !!this.connectionData.client_secret;

      return hasUsernameAndPassword || hasClientAndSecret;
    },
    hasValidUrl() {
      const regex = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!-]))?/;
      return regex.test(this.connectionData.url);
    },
  },
  async created() {
    this.SET_PAGE_TITLE_VISIBLE(false);
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
      showAlert: 'alerts/show',
    }),
    ...mapMutations(['SET_PAGE_TITLE_VISIBLE']),
    next() {
      if (this.step >= 2) {
        return;
      }

      this.step++;
    },
    prev() {
      if (this.step <= 1) {
        this.$router.go(-1);
      }
      this.step--;
    },
    connect() {
      if (!this.hasCredentials) {
        return;
      }
      this.loading = true;
      this.ticketingSetup(this.csrfToken, this.connectionData)
        .then(resp => {
          if (resp) {
            window.location = resp.redirectUrl;
            return;
          }
          this.showAlert({ type: 'success', message: 'ServiceNow is now connected' });
          this.loading = false;
          this.$router.push({
            path: '/settings/servicenow',
          });
        })
        .catch(resp => {
          this.loading = false;
          this.showAlert({ type: 'error', message: resp.message });
        });
    },
    checkNextStep() {
      if (this.hasValidUrl) {
        this.next();
      }
    },
    ticketingSetup,
  },
});
